import {
  Box,
  Tooltip,
} from "@mui/material";
import React, { useState } from "react";
import { appThemes, useMeetingAppContext } from "../MeetingAppContextDef";
import { getAnimationDuration } from "../utils/animationUtils";
import IconButtonBase from "./IconButtonBase";

const MobileIconButton = ({
  badge,
  onClick,
  Icon,
  isFocused,
  bgColor,
  focusBGColor,
  disabledOpacity,
  focusIconColor,
  disabled,
  large,
  tooltipTitle,
  btnID,
  isActive,
  buttonText,
  lottieOption,
}) => {
  const { appTheme, animationsEnabled } = useMeetingAppContext();
  const [mouseOver, setMouseOver] = useState(false);
  const [mouseDown, setMouseDown] = useState(false);

  const buttonContainerStyle = {
    padding: '0.8vh',
    borderRadius: '0.8vh',
    transition: `all ${getAnimationDuration(animationsEnabled, 200)}ms`,
    transitionTimingFunction: "linear",
  };

  const buttonInnerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <Tooltip placement="bottom" title={tooltipTitle || ""}>
      <Box style={buttonContainerStyle}>
        <Box style={buttonInnerStyle}>
          <IconButtonBase
            badge={badge}
            onClick={onClick}
            Icon={Icon}
            isFocused={isFocused}
            bgColor={bgColor}
            focusIconColor={focusIconColor}
            disabledOpacity={disabledOpacity}
            disabled={disabled}
            btnID={btnID}
            buttonText={buttonText}
            lottieOption={lottieOption}
            mouseOver={mouseOver}
            mouseDown={mouseDown}
            onMouseEnter={() => setMouseOver(true)}
            onMouseLeave={() => setMouseOver(false)}
            onMouseDown={() => setMouseDown(true)}
            onMouseUp={() => setMouseDown(false)}
            padding="0.8vh"
          />
        </Box>
      </Box>
    </Tooltip>
  );
};

export default MobileIconButton;
